/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class StandaloneConnectController extends Controller {
  queryParams = ['section', 'environment'];

  @tracked declare section: string | null;
  @tracked declare environment: string | null;
}

declare module '@ember/controller' {
  interface Registry {
    '/apps/app/standalone/connect': StandaloneConnectController;
  }
}
